import {
  DispositiveProvisions_BeneficiaryDesignationsFragment,
  DispositiveProvisions_DispositionScenarioFragment,
  DispositiveProvisions_DispositiveProvisionFragment,
} from '@/modules/dispositiveProvisions/graphql/DispositiveProvisions.fragments.generated';
import { getNodes } from '@/utils/graphqlUtils';

export function getProvisionsByDeathForScenario(
  scenario: DispositiveProvisions_DispositionScenarioFragment | undefined
) {
  const {
    dispositiveProvisions,
    dispositiveProvisionsTemplate,
    secondDeathDispositiveProvisions,
    secondDeathDispositiveProvisionsTemplate,
  } = scenario || {};

  const firstDeathProvisions =
    dispositiveProvisionsTemplate?.dispositiveProvisions ||
    dispositiveProvisions;

  const secondDeathProvisions =
    secondDeathDispositiveProvisionsTemplate?.dispositiveProvisions ||
    secondDeathDispositiveProvisions;

  return {
    firstDeathProvisions,
    secondDeathProvisions,
  };
}

/**
 * Flattens the primary/contingent dispositive-provisions from the BDG
 * resolver shape. Templates don't apply to BDGs.
 */
export function getProvisionsForBeneficiaryDesignations(
  bdgs: DispositiveProvisions_BeneficiaryDesignationsFragment | undefined | null
): {
  primaryProvisions: DispositiveProvisions_DispositiveProvisionFragment[];
  contingentProvisions: DispositiveProvisions_DispositiveProvisionFragment[];
} {
  return {
    primaryProvisions: getNodes(bdgs?.primary?.dispositiveProvisions),
    contingentProvisions: getNodes(bdgs?.contingent?.dispositiveProvisions),
  };
}
